'use client';
import React, { useState } from 'react';
import { Crown, Check, ArrowUpRight, Calendar } from 'lucide-react';
import { toast } from 'sonner';

const FREE_FEATURES = [
  '3 Dog Profiles',
  '25 Photos',
  'Basic Memory Timeline',
  'Community Paws & Celebrations',
  'Standard Certificates',
];

const PREMIUM_FEATURES = [
  'Unlimited Dog Profiles',
  '100 Photos (expandable)',
  'Portrait Studio',
  'Guestbook on all profiles',
  'Premium Certificates (100+ types)',
  'Premium Profile Themes',
  'Priority community features',
  'All future premium features',
];

export default function BillingPlanCard() {
  const [upgrading, setUpgrading] = useState(false);
  const isPremium = true; // Backend integration point: fetch user subscription status

  const handleManage = async () => {
    setUpgrading(true);
    await new Promise(r => setTimeout(r, 800));
    setUpgrading(false);
    toast?.success('Redirecting to billing portal...');
    // Backend integration point: redirect to Stripe customer portal
  };

  return (
    <div className="bg-card border border-border rounded-2xl shadow-card overflow-hidden">
      {/* Current plan header */}
      <div className="gradient-violet px-6 py-5 flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Crown size={18} className="text-accent" />
            <span className="font-800 text-lg text-white">Premium Membership</span>
          </div>
          <p className="text-white/70 text-sm">$49.95 / year · Renews June 22, 2027</p>
        </div>
        <div className="text-right">
          <div className="bg-accent text-white text-xs font-700 px-3 py-1 rounded-full">Active</div>
          <p className="text-white/60 text-xs mt-1 flex items-center gap-1 justify-end">
            <Calendar size={11} />
            365 days remaining
          </p>
        </div>
      </div>
      {/* Features */}
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Premium features */}
          <div>
            <p className="text-xs font-700 text-muted-foreground uppercase tracking-wider mb-3">Your Premium Features</p>
            <ul className="space-y-2">
              {PREMIUM_FEATURES?.map((f) => (
                <li key={`pf-${f}`} className="flex items-center gap-2 text-sm text-foreground">
                  <Check size={14} className="text-success shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
          </div>

          {/* Free plan comparison */}
          <div className="bg-muted rounded-xl p-4">
            <p className="text-xs font-700 text-muted-foreground uppercase tracking-wider mb-3">Free Plan Includes</p>
            <ul className="space-y-2">
              {FREE_FEATURES?.map((f) => (
                <li key={`ff-${f}`} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Check size={14} className="text-muted-foreground shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex gap-3 mt-6 pt-6 border-t border-border">
          <button
            onClick={handleManage}
            disabled={upgrading}
            className="paw-btn flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-xl text-sm font-700 hover:bg-secondary-foreground transition-all disabled:opacity-60"
          >
            {upgrading ? (
              <><span className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />Loading...</>
            ) : (
              <><ArrowUpRight size={15} />Manage Subscription</>
            )}
          </button>
          <button className="px-5 py-2.5 border border-border rounded-xl text-sm font-600 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors">
            Cancel Membership
          </button>
        </div>
      </div>
    </div>
  );
}